export default "__VITE_ASSET__702067ed__"